import styled from 'styled-components';
import {
  fontSizes,
  borderColors,
  spacing,
  fontWeights,
  colors,
  body2,
  heading1,
  heading4,
} from 'ui/theme';
import { pxToRem } from 'utils/convert';

const customSpacing = {
  p2: pxToRem(2),
  p12: pxToRem(12),
  p25: pxToRem(25),
  p78: pxToRem(78),
  p400: pxToRem(400),
};

export const ChartWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex: 0;
  flex-direction: column;
  height: ${customSpacing.p78};
  margin-bottom: ${customSpacing.p2};
  position: relative;
  width: 100%;
`;

export const ChartLabels = styled.div`
  align-items: center;
  display: flex;
  gap: ${spacing.threeEights};
  justify-content: start;
  top: ${spacing.threeQuarter};
`;

export const CustomLabel = styled.div`
  align-items: center;
  display: flex;
`;

export const MediumLabel = styled.span`
  font-size: ${fontSizes.s14};
  font-weight: ${fontWeights.medium};
`;

export const SendsCount = styled.span`
  color: ${colors.secondaryText};
  font-size: ${fontSizes.s14};
  font-weight: ${fontWeights.light};
`;

export const ChartsContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: ${customSpacing.p400};
  justify-content: flex-start;
  width: 100%;
`;

export const ChartContent = styled.div`
  border-radius: ${spacing.threeEights};
  background-color: ${colors.grey5};
  height: ${customSpacing.p25};
  margin-top: ${spacing.threeQuarter};
  position: relative;
  overflow: hidden;
  width: 100%;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`;

export const TitleText = styled.div`
  ${body2};
  color: ${colors.textSecondary};
  font-size: ${fontSizes.s14};
`;

export const SubLabel = styled.div`
  ${body2};
  color: ${colors.textSecondary};
  font-size: ${fontSizes.s14};
`;

export const SubLabelValue = styled.div`
  ${heading4};
  font-weight: ${fontWeights.bold};
`;

export const OverallMetricsLabel = styled.div`
  ${heading1};
  font-weight: ${fontWeights.bold};
  margin-bottom: ${spacing.half};
`;

export const OverallMetricsSubLabel = styled.div`
  align-items: center;
  display: flex;
  gap: ${spacing.half};
`;

export const ChannelRow = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: ${spacing.threeQuarter} 0;

  &:not(:last-of-type) {
    border-bottom: ${spacing.single} solid ${borderColors.neutral300};
  }
`;

export const MediumColorIndicator = styled.div`
  background-color: ${({ color }) => color};
  border-radius: 100%;
  height: ${customSpacing.p12};
  margin-right: ${spacing.half};
  width: ${customSpacing.p12};
`;
